"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDebugInfo;

var _clientjs = _interopRequireDefault(require("clientjs"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function getDebugInfo() {
  var client = new _clientjs.default();
  var debugObj = {
    userAgent: client.getUA()
  };
  return JSON.stringify(debugObj);
}